// All homepage content, mirroring /newsite structure.
// Images bundled locally under /public/assets/ — staging21 is being
// retired so we never hot-link to it at runtime.

export const CONTACT = {
  phone: "1.833.787.1885",
  phoneHref: "tel:+18337871885",
  email: "info@andersoncollege.com",
};

export const NAV_ITEMS = [
  { label: "Online Programs", href: "#program" },
  { label: "On-Campus Programs", href: "#program" },
  { label: "Admissions", href: "#admissions" },
  { label: "Why Anderson", href: "#about" },
  { label: "Student Life", href: "#student-life" },
  { label: "Financial Aid", href: "#financial-aid" },
];

export const CAMPUS_DETAILS = [
  { name: "Brampton", addr1: "499 Main Street South, Suite 60", addr2: "Brampton, ON L6Y 1N7", postal: "L6Y 1N7", lat: 43.666440, lng: -79.740170, region: "ON" },
  { name: "Brantford", addr1: "39 King George Road, Suite 104", addr2: "Brantford, ON N3R 5K2", postal: "N3R 5K2", lat: 43.162726, lng: -80.274734, region: "ON" },
  { name: "Downtown Toronto", addr1: "5775 Yonge Street, Suite 1006", addr2: "North York, ON M2M 4J1", postal: "M2M 4J1", lat: 43.783329, lng: -79.415979, region: "ON" },
  { name: "Hamilton", addr1: "31 King Street East, 2nd Floor", addr2: "Hamilton, ON L8N 1A1", postal: "L8N 1A1", lat: 43.256718, lng: -79.868140, region: "ON" },
  { name: "Kitchener", addr1: "248 Stirling Avenue South, Unit 14", addr2: "Kitchener, ON N2G 4L1", postal: "N2G 4L1", lat: 43.440547, lng: -80.485804, region: "ON" },
  { name: "London", addr1: "303 Richmond Street, Unit 100", addr2: "London, ON N6B 2H8", postal: "N6B 2H8", lat: 42.979351, lng: -81.247909, region: "ON" },
  { name: "Mississauga – Dundas", addr1: "165 Dundas Street West, 3rd Floor", addr2: "Mississauga, ON L5B 2N6", postal: "L5B 2N6", lat: 43.577422, lng: -79.620288, region: "ON" },
  { name: "Mississauga – Hurontario", addr1: "3025 Hurontario Street, Suite 600", addr2: "Mississauga, ON L5B 2N6", postal: "L5B 2N6", lat: 43.581170, lng: -79.616810, region: "ON" },
  { name: "North York", addr1: "5734 Yonge Street, Suite 100", addr2: "North York, ON M2M 4E7", postal: "M2M 4E7", lat: 43.782742, lng: -79.416835, region: "ON" },
  { name: "Windsor", addr1: "630 Tecumseh Rd E", addr2: "Windsor, ON N8X 2S2", postal: "N8X 2S2", lat: 42.298686, lng: -83.015009, region: "ON" },
];

export const FAQS = [
  {
    q: "How long are programs at Anderson College?",
    a: "Most diploma programs run between 26 and 52 weeks. Hybrid and online programs typically complete in 9–14 months, and Personal Support Worker Hybrid is 27 weeks. Each program page lists the exact length.",
  },
  {
    q: "Is financial aid available for Anderson College students?",
    a: "Yes. Qualified students can access OSAP (Ontario Student Assistance Program), Better Jobs Ontario, the Ontario Job Grant, Windmill Microlending, interest-free college financing, RRSP-based LLP funding, bank lines of credit, and several Anderson bursaries (Alumni, Cardiology Technologist).",
  },
  {
    q: "Which Anderson College campus is closest to me?",
    a: "Anderson College has 10 campuses across Ontario: Brampton, Brantford, Downtown Toronto, Hamilton, Kitchener, London, Mississauga–Dundas, Mississauga–Hurontario, North York, and Windsor. Use the Program Finder or call 1.833.787.1885 and an advisor will match you to the nearest location offering your program.",
  },
  {
    q: "Does Anderson College offer online programs?",
    a: "Yes. Online delivery is available for Accounting & Payroll Administration, Business Administration, Supply Chain and Logistics, Early Childcare Assistant, Health Information Management, Medical Office Administrator, IT Technician, Computer System Technician – Networking, Law Enforcement / Police Foundations, and Occupational Health & Safety.",
  },
  {
    q: "Is Anderson College accredited?",
    a: "Anderson College of Health, Business and Technology is registered as a private career college under the Ontario Career Colleges Act, 2005. Individual programs carry additional accreditations — including CCAPP (Pharmacy), the Law Society of Ontario (Paralegal), ODAA (Dental), CECE (Early Childhood Education) and CIFFA (Supply Chain).",
  },
  {
    q: "How do I apply to Anderson College?",
    a: "Book an appointment with an admissions advisor at andersoncollege.com/virtual-appointment or call 1.833.787.1885. Your advisor will walk you through the application, financial aid options, start dates, and campus selection — typically within one business day.",
  },
];

export const WHY_ANDERSON = [
  {
    title: "23 In Demand Programs",
    text: "Since 1885, we have proudly delivered quality training that enhances skills, empowers individuals, and builds successful futures across generations.",
    icon: "book",
  },
  {
    title: "Expert and Supportive Faculty",
    text: "Experienced, industry-expert faculty offer personalized guidance and support, ensuring strong academic and professional development for every student.",
    icon: "diamond",
  },
  {
    title: "GuardMe Student Support Program (GMSSP)",
    text: "We prioritize mental wellness through free access to GuardMe's Student Support Program, enhancing overall student well-being.",
    icon: "shield",
  },
  {
    title: "150k+ Successful Students",
    text: "With 150,000+ students, our college has launched careers across healthcare, technology, business, and community services.",
    icon: "globe",
  },
  {
    title: "Accessible Financial Assistance",
    text: "Qualified students can access multiple financial aid options with expert admission guidance for personalized funding support.",
    icon: "briefcase",
  },
  {
    title: "Hands-On Experience and Practicum",
    text: "Programs offer real-world exposure through hands-on training and practicum placements with respected industry employers.",
    icon: "tasks",
  },
];

export const TIMELINE = [
  {
    year: "1885",
    title: "James Washington Westervelt Sr. establishes college in London, Ontario.",
    img: `/assets/migrated/b86fb006f8-1885.webp`,
  },
  {
    year: "1994",
    title:
      "Westervelt (now Anderson College) receives the Community Service Award from the National Association of Career Colleges.",
    img: `/assets/migrated/cf36621da6-0a17c8882d17e49d6e8cc0d7f737928387932c25-rg6wls7azqfl44x78fh.png`,
  },
  {
    year: "2011",
    title: "Anderson College is born and establishes its first location in Toronto.",
    img: `/assets/migrated/f6447e9150-2011.webp`,
  },
  {
    year: "2020",
    title:
      "Anderson moves education online during COVID-19, establishes faculty/student support, and donates 50,000 masks to the healthcare community.",
    img: `/assets/migrated/2a5ff967b8-2020.webp`,
  },
  {
    year: "2022",
    title:
      "Anderson and Westervelt combine forces; 10 campuses across Ontario; 1000+ PSWs trained; GuardMe launched.",
    img: `/assets/migrated/cad9e33d48-2022.webp`,
  },
  {
    year: "2025",
    title:
      "Anderson celebrates 140 years; raises $15,395 for Make-A-Wish Canada; receives recognition from the Premier of Ontario.",
    img: `/assets/migrated/0b8fd10af6-2025.webp`,
  },
];

export const TESTIMONIALS = [
  {
    name: "Aleah B.",
    program: "Medical Office Administration",
    img: "https://img.youtube.com/vi/7DBPwApOaHY/hqdefault.jpg",
    videoId: "7DBPwApOaHY",
  },
  {
    name: "Sahar M.",
    program: "Medical Esthetician",
    img: "https://img.youtube.com/vi/ldf3usxF2OY/hqdefault.jpg",
    videoId: "ldf3usxF2OY",
  },
  {
    name: "Kim H.",
    program: "Medical Laboratory Assistant Technology",
    img: "https://img.youtube.com/vi/a9Spi5dx5l0/hqdefault.jpg",
    videoId: "a9Spi5dx5l0",
  },
  {
    name: "Mandeep P.",
    program: "Personal Support Worker",
    img: "https://img.youtube.com/vi/d4hIXjVA5Rc/hqdefault.jpg",
    videoId: "d4hIXjVA5Rc",
  },
  {
    name: "Samantha",
    program: "Dental Assisting",
    img: "https://img.youtube.com/vi/1iw6HoGnfIk/hqdefault.jpg",
    videoId: "1iw6HoGnfIk",
  },
];

export const FINANCIAL_AID = [
  {
    title: "Government Student Loans",
    icon: `/assets/migrated/3a761c04c7-Group-48096123.svg`,
    text: "Financial assistance may be available to those who qualify. Please visit www.osap.gov.on.ca or contact us and we will help you navigate the information on the government website.",
    link: null,
  },
  {
    title: "Better Jobs Ontario",
    icon: `/assets/migrated/df96dbf461-Group-48096126.svg`,
    text: "Better Jobs Ontario funding is education funding available for recently laid-off unemployed workers. For many, long-term skills training is essential in the transition to in-demand career opportunities. If you are a recently laid-off unemployed worker, an active EI claimant or EI reachback, you may be able to access this funding.",
    link: "/financial-aid/better-jobs-ontario",
  },
  {
    title: "Lifelong Learning Plan",
    icon: `/assets/migrated/a4dda6f01a-Group-48096137.png`,
    text: "The Lifelong Learning Plan (LLP) allows you to withdraw from your RRSPs to finance full-time training or education for you or your spouse or common-law partner.",
    link: null,
  },
  {
    title: "RESP (Registered Education Savings Plans)",
    icon: `/assets/migrated/107dff8575-Group-48096139.svg`,
    text: "Students who have been named a beneficiary under a family member's Registered Education Savings Plan (RESP), may use funds from the RESP to finance their education.",
    link: null,
  },
  {
    title: "College Interest-Free Financing",
    icon: `/assets/migrated/e59dd6c472-Group-48096141.svg`,
    text: "Anderson College provides interest-free financing for self-funded students. For more information, please contact us and speak to one of our advisors.",
    link: null,
  },
  {
    title: "Bank Solutions",
    icon: `/assets/migrated/666cec419a-Group-48096143.svg`,
    text: "Most Canadian banks and credit unions offer student loans or lines of credit to finance your education. Please visit your bank for more information.",
    link: null,
  },
  {
    title: "Ontario Job Grant",
    icon: `/assets/migrated/99af6bf872-Group-48096145.svg`,
    text: "The Ontario Job Grant provides direct financial support to individual employers who wish to purchase training for their employees.",
    link: "https://www.ontario.ca/page/ontario-job-grant",
    external: true,
  },
  {
    title: "Windmill Microlending",
    icon: `/assets/migrated/ab083a2180-Group-48096147.svg`,
    text: "Windmill Microlending, a registered charity since 2005, offers low-interest microloans of up to $15,000 to skilled immigrants and refugees to help obtain Canadian licensing or training required to work in your field.",
    link: "/financial-aid/windmill-microlending",
  },
  {
    title: "Alumni Bursary",
    icon: `/assets/migrated/0771add6d7-Group-48096149.svg`,
    text: "The Anderson College Alumni Bursary provides graduates with up to $1,000 toward tuition for a second program. Designed to support continued education and career growth.",
    link: "/financial-aid/alumni-bursary",
  },
  {
    title: "Cardiology Technologist Bursary",
    icon: `/assets/migrated/0771add6d7-Group-48096149.svg`,
    text: "The Anderson College Cardiology Technologist Bursary supports continued education and career growth for eligible students based on program tuition and other conditions.",
    link: "/financial-aid/cardiology-technologist-bursary",
  },
];

export const BLOG_POSTS = [
  // NOTE: These point at `.webp` directly (not `.png`) so SmartImg renders a
  // plain <img> rather than a <picture><source>. The <picture> path is
  // MIME-type sensitive on some CDNs and was silently breaking on production
  // when CloudFront/Cloudflare served `.webp` with `application/octet-stream`.
  // Browsers decode <img> from magic bytes regardless of content-type, so
  // this is the bulletproof path for the homepage's most-viewed cards.
  {
    title: "Cardiology Technologist Day in the Life: Inside a Real Clinical Workflow",
    img: `/assets/migrated/1800c4555b-CT-blog-Banner.webp`,
    href: "/blog/cardiology-technologist-day-in-the-life-inside-a-real-clinical-workflow",
  },
  {
    title: "The Power of Perseverance – Anderson Connect",
    img: `/assets/migrated/ed029fe6f0-connect-blog-Banner.webp`,
    href: "/blog/the-power-of-perseverance-anderson-connect",
  },
  {
    title:
      "From Nervous Beginnings to Success in a PSW Course: Christine's Journey",
    img: `/assets/migrated/553566eafc-Christine-PSW-blog-Banner.webp`,
    href: "/blog/from-nervous-beginnings-to-success-in-a-psw-course-christines-journey",
  },
];

// Accreditation / affiliation partner logos displayed in the home-page
// marquee. Converted 2026-10 from a flat image list to {src, name}
// objects so each image's alt text names the actual organisation
// (replaced the generic "Accreditation" alt that duplicated 11 times
// in the DOM and failed the home-page SEO audit).
//
// The `name` strings below are our best mapping as of 2026-10-19 based
// on the brand marks in each file. If marketing confirms the exact
// organisation for a given slot, update the string here and nowhere
// else — the Accreditations component reads this list directly.
export const ACCREDITATIONS = [
  { src: `/assets/migrated/58cffe3665-Rectangle-4658-2-1-1.png`, name: "Ministry of Colleges and Universities (Ontario)" },
  { src: `/assets/migrated/4f844bd420-Rectangle-4660-1-1.png`,   name: "National Association of Career Colleges (NACC)" },
  { src: `/assets/migrated/b629ab05a2-Rectangle-4662-1-1.png`,   name: "Career Colleges Ontario" },
  { src: `/assets/migrated/c37e32b1c5-Rectangle-4652-1.png`,     name: "Law Society of Ontario" },
  { src: `/assets/migrated/44dd1a3526-Rectangle-4663-1.png`,     name: "National Dental Assisting Examining Board (NDAEB)" },
  { src: `/assets/migrated/7601542921-Rectangle-4653-1-1.png`,   name: "Canadian Council for Accreditation of Pharmacy Programs (CCAPP)" },
  { src: `/assets/migrated/08bb9c9ce4-Frame-2121453689.png`,     name: "Accreditation Canada — EQual" },
  { src: `/assets/migrated/b4eb895b69-Frame-2121453694.png`,     name: "Canadian Society of Cardiology Technologists (CSCT)" },
  { src: `/assets/migrated/69b3c58b33-Rectangle-4654-1-1.png`,   name: "Ontario College of Pharmacists (OCP)" },
  { src: `/assets/migrated/a67dac5df2-Rectangle-4655-1-1.png`,   name: "College of Medical Laboratory Technologists of Ontario (CMLTO)" },
  { src: `/assets/migrated/c2c091e847-Rectangle-4656-1-1.png`,   name: "Ontario Association of Certified Engineering Technicians and Technologists (OACETT)" },
];

export const PROGRAMS_BY_DELIVERY = {
  online: [
    { group: "Business & Logistics", items: ["Accounting & Payroll Administration Diploma", "Business Administration", "Supply Chain and Logistics"] },
    { group: "Childcare", items: ["Early Childcare Assistant"] },
    { group: "Healthcare", items: ["Health Information Management", "Medical Office Administrator (Online)"] },
    { group: "Information Technology", items: ["Information Technology (IT) Technician", "Computer System Technician – Networking"] },
    { group: "Law", items: ["Law Enforcement / Police Foundations"] },
    { group: "Occupational Health & Safety", items: ["Occupational Health & Safety"] },
  ],
  "on-campus": [
    { group: "Cardiology & Medical Imaging", items: ["Cardiology Technologist", "Diagnostic Medical Sonographer"] },
    { group: "Childcare", items: ["Early Childhood Education"] },
    { group: "Dental Assisting", items: ["Intra Oral Level I & II Dental Assistant"] },
    { group: "Healthcare & Wellness", items: ["Medical Esthetician", "Medical Office Administrator (In-Campus)", "Orthopaedic Technician", "Personal Support Worker – Hybrid (27 Weeks)", "Pharmacy Assistant", "Pharmacy Technician"] },
    { group: "Law", items: ["Paralegal"] },
    { group: "Medical Laboratory Sciences", items: ["Medical Laboratory Assistant Technician", "Medical Laboratory Technology Hybrid"] },
  ],
};

export const CAMPUSES = [
  "Brampton | Ontario",
  "Brantford | Ontario",
  "Downtown Toronto | Ontario",
  "Hamilton | Ontario",
  "Kitchener | Ontario",
  "London | Ontario",
  "Mississauga Dundas | Ontario",
  "Mississauga Hurontario | Ontario",
  "North York | Ontario",
  "Surrey | British Columbia",
  "Windsor | Ontario",
];
